<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3">
    <div class="col-md-12 mb-2">
      <label for="name" class="payingClinic col-md-6 required" *ngIf="createFlag || updateNameFlag">Name</label>
      <input type="text" class="form-control d-inline-block input-font inputBox col-md-6" id="name" [(ngModel)]="name"
        *ngIf="createFlag || updateNameFlag">
    </div>
    <div class="col-md-12 mb-2">
      <label for="email" class="payingClinic col-md-6 required" *ngIf="createFlag">Email</label>
      <input type="text" class="form-control d-inline-block input-font inputBox col-md-6" id="email" [(ngModel)]="email"
        *ngIf="createFlag">
    </div>
    <div class="col-md-12 mb-2">
      <label for="phone" class="payingClinic col-md-6 required" *ngIf="createFlag">Phone</label>
      <input type="text" class="form-control d-inline-block input-font inputBox col-md-6" id="phone" [(ngModel)]="phone"
        *ngIf="createFlag">
    </div>
    <div class="col-md-12 mb-2">
      <label for="role" class="payingClinic col-md-6 required" *ngIf="createFlag || updateRoleFlag">Role</label>
      <select name="role" class="form-control input-font name inputBox col-md-6" [(ngModel)]="role"
        *ngIf="createFlag || updateRoleFlag">
        <option value="Admin">Admin</option>
        <option value="Operations">Operations</option>
        <option value="Accounts">Accounts</option>
        <option value="Marketing">Marketing</option>
        <option value="Developers">Developers</option>
      </select>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row col-md-12 ml-3">
    <button mat-button class="mat-raised-button mr-4 btn blankTurquoise btnWidth"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button d-inline-block btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="createUser()" *ngIf="createFlag">Create</button>
    <button mat-button class="mat-raised-button d-inline-block btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="updateName()" *ngIf="updateNameFlag">Update</button>
    <button mat-button class="mat-raised-button d-inline-block btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="updateRole()" *ngIf="updateRoleFlag">Update</button>
  </div>
</mat-dialog-actions>
